import { FC } from 'react';

import { ListCardGroup } from 'components/list-card-group';
import { t } from 'state/intl/translations';
import { TranslationKey } from 'state/intl/types';

import { Modifier } from '../modifier/modifier';
import { IModifierData } from '../modifier/types';

import { SelectModifierFn } from './types';

export interface IModifierGroup {
  key: string;
  displayGroupName?: TranslationKey;
  modifiers: IModifierData[];
}

export type IModifierGroupProps = IModifierGroup & {
  onModifierSelectionChange: SelectModifierFn;
};

export const ModifierGroup: FC<IModifierGroupProps> = ({
  displayGroupName,
  modifiers,
  onModifierSelectionChange,
}) => {
  return (
    <ListCardGroup
      items={modifiers}
      header={displayGroupName ? t(displayGroupName) : undefined}
      renderItem={({ item: modifierProps }: { item: IModifierData }) => (
        <Modifier
          {...modifierProps}
          key={`modifier-${modifierProps.modifier.id}`}
          onSelectionsChange={selections =>
            onModifierSelectionChange(selections, modifierProps.modifier)
          }
        />
      )}
    />
  );
};
